import { render, staticRenderFns } from "./svg-arrow.vue?vue&type=template&id=64c75bc4&"
import script from "./svg-arrow.vue?vue&type=script&lang=js&"
export * from "./svg-arrow.vue?vue&type=script&lang=js&"
import style0 from "./svg-arrow.vue?vue&type=style&index=0&id=64c75bc4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports